<template>
  <div class="gang-sheet-builder-variants">
    <span class="gang-sheet-builder-variants__title"> Select variant </span>
    <div class="gang-sheet-builder-variants__tiles">
      <Tile
        v-for="(variant, label) in gangSheetBuilderVariants"
        :key="variant.variant_id"
        :value="{ label, value: variant.variant_id }"
        :is-selected="isSelected(variant.variant_id)"
        @tile-selected="handleTileSelected"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "pinia";
import { upsertQueryParam } from "common/utils/browser";
import Tile from "./Tile.vue";
import { useDtfStore } from "../store";

export default {
  name: "Variants",
  components: {
    Tile
  },
  computed: {
    ...mapState(useDtfStore, ["gangSheetBuilderVariants", "gangSheetBuilderSettings"])
  },
  methods: {
    ...mapActions(useDtfStore, [
      "updateGangSheetBuilderSettings",
      "setProductSlug",
      "setVariantId"
    ]),
    ...mapActions(useDtfStore, ["updatePdpDates", "updateBulkTable", "updateCarouselImage"]),
    handleTileSelected(value) {
      const variantObj = Object.values(this.gangSheetBuilderVariants).find(
        variant => variant.variant_id === value
      );

      this.setVariantId(value);
      this.updateGangSheetBuilderSettings({ variantId: value });
      this.setProductSlug(variantObj.product_slug);
      this.updatePdpDates();
      this.updateBulkTable();
      this.updateCarouselImage({ variantId: value });
      upsertQueryParam("v", variantObj.catalog_number, { redirect: false, replace: false });
    },
    isSelected(variantId) {
      return this.gangSheetBuilderSettings.variantId === variantId;
    }
  },
  mounted() {
    this.updateCarouselImage({ variantId: this.gangSheetBuilderSettings.variantId });
  }
};
</script>

<style lang="scss">
@import "frontend/init/jiffy/settings.scss";

.gang-sheet-builder-variants {
  &__title {
    font-size: 17px;
    font-weight: 700;
  }

  &__tiles {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 16px;
  }
}
</style>
